import { Card, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import '../NewDashboard.css';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { getSingleProjectAllocationDetails } from 'src/services/projectService';
import { RootStateType } from 'src/store/RootReducer';
import { toast } from 'react-toastify';

const getWeekStartAndEndDates = () => {
  const currentDate = new Date();
  const startDate = new Date(currentDate);
  startDate.setDate(currentDate.getDate() - currentDate.getDay());
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);
  return { startDate, endDate };
};

const ProjectsWidget = () => {
  const [projects, setProjects] = useState([]);
  const outerDivRef = useRef(null);
  const empId = useSelector(
    (state: RootStateType) => state.appReducer?.user?.EmployeeId
  );

  const generateDynamicColor = (index) => {
    const colors = [
      '#D9D0C7', '#88C0D0', '#5E81AC', '#3B4252', '#EBCB8B',
      '#A3BE8C', '#B48EAD', '#4C566A', '#D08770', '#ECEFF4'
    ];
    return colors[index % colors.length];
  };

  useEffect(() => {
    const fetchProjectAllocationDetails = async () => {
      const { startDate, endDate } = getWeekStartAndEndDates();
      const body = {
        employeeId: empId,
        filter: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString()
        }
      };

      try {
        const response = await getSingleProjectAllocationDetails(body);
        if (response?.data?.allocations) {
          setProjects(
            response.data.allocations.map((allocation, index) => ({
              id: allocation.id,
              name: allocation.projectName,
              percentage: allocation.allocation,
              color: generateDynamicColor(index)
            }))
          );
        }
      } catch (error) {
        toast.error('Failed to fetch project allocation details.');
      }
    };

    fetchProjectAllocationDetails();
  }, []);

  return (
    <Card
      style={{
        paddingTop: '1rem',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '2rem',
        overflowY: 'auto',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
      className="card-projects"
    >
      <div>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4" sx={{ fontSize: 14 }}>
            <FileCopyIcon style={{ fontSize: '18px' }} /> My Projects
          </Typography>
          <Typography variant="subtitle2" sx={{ fontSize: 12, color: 'gray' }}>
            (Current week)
          </Typography>
        </Grid>
        <div
          ref={outerDivRef}
          style={{
            display: 'flex',
            marginTop: '1rem',
            height: '24px',
            width: '100%',
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
            overflow: 'hidden'
          }}
        >
          {projects.length > 0 ? (
            projects.map((project) => (
              <div
                key={project.id}
                style={{
                  flex: project.percentage,
                  backgroundColor: project.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  minWidth: '20px' // Ensures very small percentages are visible
                }}
              >
                <span style={{
                  color: '#FFFFFF',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  textShadow: '0 0 2px rgba(0,0,0,0.5)'
                }}>
                  {project.percentage}%
                </span>
              </div>
            ))
          ) : (
            <div style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Typography
                variant="subtitle1"
                sx={{ fontSize: 14, color: 'gray' }}
              >
                No project allocations available
              </Typography>
            </div>
          )}
        </div>

        {/* Legend */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '1rem',
            gap: '8px'
          }}
        >
          {projects.map((project) => (
            <div
              key={project.id}
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: project.color,
                  marginRight: '0.5rem',
                  borderRadius: '3px'
                }}
              />
              <Typography variant="body2" sx={{ fontSize: 12 }}>
                {project.name} <span style={{ color: '#666' }}>({project.percentage}%)</span>
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default ProjectsWidget;